// extracted by mini-css-extract-plugin
export default {"btn":"PlanBTLink_btn__0CY9a"};